<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class="print:hidden rounded-3xl mr-0 shadow-[0_4px_18px_rgba(0,0,0,0.04)] app-background"
  [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation.default"
  [opened]="!isScreenSmall"
  (openedChanged)="isNavigationOpened = $event">
  <!-- Navigation header -->
  <ng-container fuseVerticalNavigationHeader>
    <div class="flex items-center w-full p-4 pl-6 pt-6">
      <div class="flex items-center justify-center shrink-0">
        <img class="w-auto h-4 object-contain dark:hidden" src="assets/images/logo/drivr-black.png" alt="Logo" />
        <img class="w-auto h-4 object-contain hidden dark:block" src="assets/images/logo/drivr-white.png" alt="Logo" />
      </div>

      <div class="flex items-center ml-auto">
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
          <mat-icon svgIcon="heroicons_outline:bars-3"></mat-icon>
        </button>
      </div>
    </div>
  </ng-container>
  
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0 app-background">
  <!-- Content Card -->
  <div
    class="flex flex-col flex-auto bg-[#fcfcfc] dark:bg-gray-900 rounded-none shadow-none lg:shadow-[0_4px_28px_rgba(0,0,0,0.06)] dark:lg:shadow-[0_10px_50px_rgba(0,0,0,0.3)] lg:border-0 dark:lg:border dark:border-gray-800/60 m-0 overflow-hidden min-h-0 transition-all"
    [class.lg:ml-0]="isNavigationOpened">
    <!-- Header inside card -->
    <div
      class="relative flex items-center justify-between shrink-0 h-14 sm:h-16 px-4 sm:px-6 md:px-8 border-b border-gray-200 dark:border-gray-800 transition-shadow duration-300 z-10"
      [ngClass]="{'shadow-md border-transparent': isScrolled}">
      <!-- Toggle menu (Visible on mobile, or when nav is closed on desktop) -->
      <button class="-ml-2 text-gray-600 dark:text-gray-400 shrink-0 transition-opacity" 
        [class.hidden]="!isScreenSmall && isNavigationOpened"
        mat-icon-button
        (click)="toggleNavigation('mainNavigation')">
        <mat-icon svgIcon="heroicons_outline:bars-3"></mat-icon>
      </button>

      <!-- Event Ticker -->
      <div class="flex flex-auto items-center overflow-hidden mx-4 h-6">
        <event-ticker class="w-full"></event-ticker>
      </div>

      <div class="flex items-center space-x-3 text-gray-500 dark:text-gray-400 shrink-0 pt-1 lg:pt-0">
        <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
        <search appearance="bar"></search>
        <user></user>
      </div>
    </div>

    <!-- Scroll area -->
    <div #scrollArea class="flex flex-col flex-auto overflow-y-auto min-h-0" (scroll)="onScroll($event)">
      <div class="flex flex-col flex-auto min-h-0">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>